const $ = jQuery

export default () => {
  const is_mobile = () => $(window).width() <= 900
  const $nav = $('header .header__nav ul:first-of-type')
  const nav = document.querySelector('header .header__nav ul:first-of-type')
  const $burger = $('#hamburger')
  $(window).on('click', function(e) {
    if (is_mobile() && !$(e.target).closest('header').length && $nav.is(':visible')) $burger.trigger('click');
  });
  $(window).on('resize', function(e) {
    if (!is_mobile()) {
      $burger.removeClass('change')
      nav.style.display = null
    }
  });
  $burger.on('click', function() {
    $(this).toggleClass('change'), $nav.slideToggle()
  });
}
